export type ApiErrorType =
  | 'not_found'
  | 'invalid_email_password'
  | 'email_already_exists'
  | 'gmail_not_found'
  | 'invalid_password_reset_token'
  | 'invalid_invitation_token'
  | 'email_already_member'
  | 'email_already_invited'
  | 'constant_contact_auth'
  | 'page_already_has_donations'
  | 'page_already_has_scheduled_campaigns'
  | 'workspace_already_has_scheduled_campaigns'
  | 'missing_stripe_account'
  | 'date_time_is_in_past'
  | 'page_not_published'
  | 'email_invalid'
  | 'phone_number_invalid'
  | 'phone_number_not_us'
  | 'workspace_has_published_pages'
  | 'invalid_mailchimp_api_key'
  | 'no_mailchimp_audiences'
  | 'no_constant_contact_contacts'
  | 'invalid_billing_token'
  | 'contact_has_existing_orders'
  | 'missing_stripe_account'
  | 'page_not_published'
  | 'requires_kindest_pro'
  | 'page_not_published'
  | 'no_facebook_pages'
  | 'facebook_post_already_scheduled'
  | 'only_onetime_donations_allowed'
  | 'only_monthly_donations_allowed'
  | 'page_has_monthly_donation_tiers'
  | 'page_has_onetime_donation_tiers'
  | 'workspace_same_ein_exist'
  | 'nonprofit_not_found'
  | 'self_service_registration_unavailable'
  | 'invalid_donor_sign_in_token'
  | 'invalid_email_verification_token'
  | 'email_verification_resend_throttled'
  | 'stripe_account_already_connected'
  | 'custom_domain_already_exists'
  | 'invalid_double_the_donation_keys'
  | 'segment_already_exists'
  | 'tag_used_segment'
  | 'tag_already_exists'
  | 'interest_area_already_exists'
  | 'interest_area_already_assigned'
  | 'institution_existing_orders'
  | 'institution_already_connected'
  | 'allocation_duplicate_name'
  | 'allocation_has_existing_orders'
  | 'stripe_refund_error'
  | 'payment_method_unsupported'
  | 'payment_setup_retry'
  | 'donation_code_conflict'
  | 'feature_disabled'
  | 'custom_field_key_exists'

export const apiError = (
  error: any,
  handler: { [key in ApiErrorType]?: () => void },
  // Runs when nothing matched, including a network or untyped failure, which
  // carries no extensions.type and would otherwise pass silently.
  fallback?: () => void
) => {
  const errorType = error?.graphQLErrors?.[0]?.extensions?.type
  const fn = handler[errorType as ApiErrorType] ?? fallback

  if (fn) {
    fn()
    return
  }

  console.error(`Unhandled API error: ${errorType ?? 'unknown'}`)
}

// The public page query errors for a missing page and for an API or network
// failure alike. Only the first one is a real 404.
export const isMissingPageError = (error: any) =>
  error?.graphQLErrors?.some(
    (graphqlError: any) =>
      graphqlError?.extensions?.type === 'not_found' &&
      graphqlError?.extensions?.entity === 'page'
  ) === true
